var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenefit1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.692,
    height: 22.974,
    viewBox: "0 0 19.692 22.974",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5934",
    "data-name": "Group 5934",
    transform: "translate(-7.3 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5913",
    "data-name": "Group 5913",
    transform: "translate(20.99 7.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89801",
    "data-name": "Path 89801",
    d: "M43.5,13.882c.711,1.106.948,1.3,1.067,1.857h1.5c.672-.119,1.106-.356,1.106-1.027a1.046,1.046,0,0,0-1.027-1.027H44.211A.987.987,0,0,0,43.5,13.882Z",
    transform: "translate(-43.5 -13.675)",
    fill: "#5476ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5914",
    "data-name": "Group 5914",
    transform: "translate(10.469 5.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89802",
    "data-name": "Path 89802",
    d: "M18.389,20.721c1.027-1.778,2.094-3.358,2.924-4.741l-.356.2a.407.407,0,0,1-.4-.711c3.042-1.5,3.477-2.173,3.832-1.7.435.474,1.106,2.094,2.252,1.3a1,1,0,0,0,.277-1.462c-1.778-2.37-.869-2.252-2.805-2.608-2.647-.514-2.133-.869-3.635.514-.474.435-1.067.948-1.9,1.62s-1.62.474-2.687.474v6.716C16.848,20.405,17.559,20.168,18.389,20.721Z",
    transform: "translate(-15.9 -10.547)",
    fill: "#5476ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5915",
    "data-name": "Group 5915",
    transform: "translate(20.753 9.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89803",
    "data-name": "Path 89803",
    d: "M43.848,22.854h1.936a1.031,1.031,0,0,0,1.027-.948A1.1,1.1,0,0,0,45.705,20.8H44.243A1.945,1.945,0,0,1,42.9,22.222.988.988,0,0,0,43.848,22.854Z",
    transform: "translate(-42.9 -20.8)",
    fill: "#5476ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5916",
    "data-name": "Group 5916",
    transform: "translate(16.709 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89804",
    "data-name": "Path 89804",
    d: "M33.306,5.529c1.659.356,2.331.356,2.845,1.106l.079.158a2.211,2.211,0,0,1,.79-.316L38.442,3.04V3H38.4l-2.884.632c-.2.04-.237.04-.988-.119C34.1,3.435,33.425,3.277,32.24,3H32.2v.04Z",
    transform: "translate(-32.2 -3)",
    fill: "#5476ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5917",
    "data-name": "Group 5917",
    transform: "translate(20.674 15.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89805",
    "data-name": "Path 89805",
    d: "M45.663,35.3H43.727a1.027,1.027,0,1,0,0,2.054h1.936a1.02,1.02,0,0,0,1.027-1.027A1,1,0,0,0,45.663,35.3Z",
    transform: "translate(-42.7 -35.3)",
    fill: "#5476ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5918",
    "data-name": "Group 5918",
    transform: "translate(20.674 12.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89806",
    "data-name": "Path 89806",
    d: "M45.663,28H43.727a1.027,1.027,0,0,0,0,2.054h1.936a1.046,1.046,0,0,0,1.027-1.027A1.02,1.02,0,0,0,45.663,28Z",
    transform: "translate(-42.7 -28)",
    fill: "#5476ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5919",
    "data-name": "Group 5919",
    transform: "translate(7.3 7.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89807",
    "data-name": "Path 89807",
    d: "M9.908,23.515V16.009h0V15.1H8.09a.792.792,0,0,0-.79.79v7.586a.792.792,0,0,0,.79.79H9.908v-.751Z",
    transform: "translate(-7.3 -15.1)",
    fill: "#5476ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5920",
    "data-name": "Group 5920",
    transform: "translate(18.895 20.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89808",
    "data-name": "Path 89808",
    d: "M37.6,50v1.462c.435-.04.83-.277.83-.711C38.43,50.277,38.074,50.119,37.6,50Z",
    transform: "translate(-37.6 -50)",
    fill: "#5476ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5921",
    "data-name": "Group 5921",
    transform: "translate(17.633 18.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89809",
    "data-name": "Path 89809",
    d: "M34.3,44.232c0,.435.316.593.79.751V43.6C34.656,43.6,34.3,43.837,34.3,44.232Z",
    transform: "translate(-34.3 -43.6)",
    fill: "#5476ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5922",
    "data-name": "Group 5922",
    transform: "translate(10.811 9.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89810",
    "data-name": "Path 89810",
    d: "M31.866,28.76a1.728,1.728,0,0,1-1.3.553H28.626a1.809,1.809,0,0,1-1.106-3.24,1.778,1.778,0,0,1,0-2.845,1.663,1.663,0,0,1-.632-.988c-1.027-.158-1.343-1.067-1.778-1.541l-1.3.711c-1.383,2.489-7.665,10.865-5.689,13.709,2.133,3.082,13.314,3.042,15.606,0C34,34.725,34.355,33.382,31.866,28.76Zm-6.282,5.847V35.2H25.07v-.593a3.342,3.342,0,0,1-1.975-.869l.593-.711a2.743,2.743,0,0,0,1.383.711v-1.58c-1.067-.237-1.778-.593-1.778-1.62a1.667,1.667,0,0,1,1.778-1.62v-.4h.514v.4a3.521,3.521,0,0,1,1.7.593l-.514.751a3.21,3.21,0,0,0-1.146-.474v1.541h.04c1.027.237,1.817.593,1.817,1.659A1.83,1.83,0,0,1,25.584,34.607Z",
    transform: "translate(-17.736 -20.7)",
    fill: "#5476ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefit1);
export default __webpack_public_path__ + "static/media/Benefit_1.8f4ad02b735d68c3c84cf5398bd7a5ea.svg";
export { ForwardRef as ReactComponent };